import React, {useState} from 'react'
import styled from "styled-components"
import { Marginer } from "../../Components/marginer";
import { Typography, Card, CardActions, CardContent, CardMedia, CssBaseline, Grid, Container} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles"
import useStyles from "./cardstyles"
import CardImg from "../../images/stun2.png"
import CardImg2 from "../../images/oneclick2.png"
import CardImg3 from "../../images/free3.png"

const cards = [{
	id: 1,
	img: CardImg,
	title: "Stunning Design"
},
{
	id: 2,
	img: CardImg2,
	title: "One Click Portfolio"	
},
{
	id: 3,
	img: CardImg3,
	title: "Free"
}]

const InputContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex;
	width: 100%
`;

const Title = styled.h2`
	margin: 0;
	line-height: 1.4;
	color: #fff;
	font-weight: 600;
	font-size: 40px;
	text-align: center;
`;	


export function CardC(props) {
  const classes = useStyles()
  return (
  	<>
  	<InputContainer>
  	<Title>Why Choose GitToPort?</Title>
  	<Marginer direction="vertical" margin={25} />
  	<Container className={classes.cardGrid} maxwidth="md">
  		<Grid container spacing={4}>
  		{cards.map((card) => (
  			<Grid item key={card} xs={12} sm={6} md={4}>
  				<Card className={classes.card}>
  					<CardMedia
  						className={classes.cardMedia}
  						image= { card.img }
  						title= "Cards"
  					/>
  					<CardContent className={classes.cardContent}>
  						<Typography gutterBottom variant="h6">
  							{ card.title }
  						</Typography>
  					</CardContent>
  				</Card>  
  			</Grid>
  		))}
  		</Grid>
  	</Container>
  	</InputContainer>
  	</>
  );
}